// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../@nuxt/webpack/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".viewport[data-v-54df6e7e]{position:relative}.viewport canvas[data-v-54df6e7e],.viewport video[data-v-54df6e7e]{position:absolute;left:0;top:0}", ""]);
// Exports
module.exports = exports;
